import { apiClient } from './config'
import type { LoginData, PublicUser, SignupData, OtpVerificationData, SuccessfulLogin } from '../types'

export const userApi = {
  /**
   * Connexion utilisateur
   */
  login: async (loginData: LoginData, clientId: string): Promise<SuccessfulLogin & { httpStatus: number }> => {
    const response = await apiClient.post(`/user/login?clientId=${clientId}`, loginData, {
      validateStatus: (status) => status === 302 || (status >= 200 && status < 300),
    })
    return { ...response.data, httpStatus: response.status }
  },

  /**
   * Création de compte utilisateur
   */
  signup: async (signupData: SignupData): Promise<string> => {
    const response = await apiClient.post('/user', signupData)
    return response.data
  },

  /**
   * Vérification OTP
   */
  verifyOtp: async (otpData: OtpVerificationData, clientId: string): Promise<SuccessfulLogin> => {
    const response = await apiClient.post(`/user/verify-otp?clientId=${clientId}`, otpData)
    return response.data
  },

  /**
   * Récupère les informations de l'utilisateur connecté via le token JWT
   */
  getMe: async (): Promise<PublicUser> => {
    const response = await apiClient.get('/user/me')
    return response.data
  },

  requestPasswordReset: async (email: string, resetUrlPrefix: string): Promise<string> => {
    const response = await apiClient.post('/user/forgot-password', { email, resetUrlPrefix })
    return response.data
  },

  resolveResetPasswordEmail: async (token: string): Promise<{ email: string }> => {
    const response = await apiClient.get('/user/reset-password/email', {
      params: { token },
    })
    return response.data
  },

  resetPassword: async (token: string, password: string): Promise<string> => {
    const response = await apiClient.post('/user/reset-password', { token, password })
    return response.data
  },
  /**
   * Met à jour le prénom et le nom de l'utilisateur connecté
   */
  updateMe: async (firstName: string, lastName: string): Promise<PublicUser> => {
    const response = await apiClient.put('/user/me', { firstName, lastName })
    return response.data
  },

  /**
   * Supprime le compte de l'utilisateur connecté
   */
  deleteMe: async (): Promise<void> => {
    await apiClient.delete('/user/me')
  },
}
